import React, { createContext, useCallback, useContext, useMemo, useRef } from 'react';

const QuickEntryContext = createContext(null);

export const QuickEntryProvider = ({ children }) => {
  const candidateRefetchRef = useRef(null);

  const registerCandidateRefetch = useCallback(getData => {
    candidateRefetchRef.current = getData;

    return () => {
      if (candidateRefetchRef.current === getData) {
        candidateRefetchRef.current = null;
      }
    };
  }, []);

  const refetchCandidateQuickEntries = useCallback(() => {
    candidateRefetchRef.current?.();
  }, []);

  const value = useMemo(
    () => ({ refetchCandidateQuickEntries, registerCandidateRefetch }),
    [refetchCandidateQuickEntries, registerCandidateRefetch]
  );

  return <QuickEntryContext.Provider value={value}>{children}</QuickEntryContext.Provider>;
};

export const useQuickEntryContext = () => {
  const context = useContext(QuickEntryContext);

  if (context === null) {
    throw new Error('useQuickEntryContext must be used within a QuickEntryProvider');
  }

  return context;
};
